import $ from 'jquery/src/jquery';

$(document).ready(function($) {
    const $document = $(document);
    const $body = $('body');
    const $siteHeader = $('.siteHeader');
    const $siteNav = $('.siteNav');
    const $menuButton = $('#btnMenu');

    function documentWidthHandler() {
        $(':root').css('--document-width', $body.outerWidth() + 'px');
    }
    documentWidthHandler();
    $(window).resize(documentWidthHandler);


    function toggleMenu(e) {
        isMenuOpen() ? closeMenu(e) : openMenu(e);
    }

    function closeMenu(e) {
        $siteHeader.removeClass('siteHeader--navVisible');
        $menuButton.removeClass('close');
        $siteNav.removeClass('siteNav--visible');
        $siteNav.find('.menu-item.hover').removeClass('hover');
        $siteNav.find('.sub-menu.visible').removeClass('visible');
        $('#navOverlay').removeClass('navOverlay--visible');
        //$body.css('overflow', '');
    }

    function openMenu(e) {
        e.stopPropagation();
        $siteHeader.addClass('siteHeader--navVisible');
        $menuButton.addClass('close');
        $siteNav.addClass('siteNav--visible');
        $('#navOverlay').addClass('navOverlay--visible');
        //$body.css('overflow', 'hidden');
    }

    function isMenuOpen() {
        return $siteNav.hasClass('siteNav--visible');
    }

    $body.append('<div id="navOverlay" class="navOverlay"/>');
    $menuButton.on('click', toggleMenu);

    $('.primaryMenu, .secondaryMenu').on('click', '.menu-item-link-wrapper', function (e) {
        if ( window.outerWidth < 1260 ) {
            const $item = $(this).closest('.menu-item');
            if ($(this).next('.sub-menu').hasClass('sub-menu-depth-0')) {
                //$menu.list.find('.menu-item-has-children.open').not($item).find('.sub-menu-depth-0:visible').slideUp();
                //$menu.list.find('.menu-item-has-children.open:has(.sub-menu-depth-0)').not($item).removeClass('open');
            }
            $item.toggleClass('open');
            $(this).next('.sub-menu').slideToggle();
        }
    });

    $('.primaryMenu').on('click', 'a[href*=\\#]', function (e) {
        const href = $(this).attr('href');
        const hash = href.substring(href.indexOf('#'));
        if ($(hash).length) {
            closeMenu();
        }
    });

    $document.on('mouseenter click', '.primaryMenu > .menu-item > .menu-item-link-wrapper', function (e) {
        const $item = $(this);
        const $menuItem = $item.parents('.menu-item');
        $menuItem.addClass('hover');
        $menuItem.find('.sub-menu').addClass('visible');
        $('#navOverlay')
            .addClass('navOverlay--visible')
            .css('height', $menuItem.children('.sub-menu').outerHeight() + $('.siteHeader').outerHeight());
    });
    $document.on('mouseleave', '.primaryMenu > .menu-item', function (e) {
        const $menuItem = $(this);
        $menuItem.removeClass('hover');
        $menuItem.find('.sub-menu').removeClass('visible');
        $('#navOverlay').removeClass('navOverlay--visible');
    });


    $('.languagesMenu').on('click', '.menu-item-link-wrapper', function (e) {
        if ( window.outerWidth < 1260 ) {
            const $item = $(this).closest('.menu-item');
            $item.toggleClass('open');
        }
    });


    $(document).on('click', '.menu-item-gtranslate > a', function (e) {
        e.preventDefault();
        if (window.outerWidth < 1260) {
            const $menuItem = $(this).parents('.menu-item-gtranslate');
            $menuItem.toggleClass('open');
            $menuItem.find('.sub-menu').slideToggle();
        }
    });
})
